import { Paths } from "configs";

import { LoginComponent } from "../components/LoginComponent";

export const SignContractRoutes = [
  { path: Paths.signContract, element: <LoginComponent /> },
];
